import { render, staticRenderFns } from "./proComFour.vue?vue&type=template&id=50f5cda2&scoped=true&"
import script from "./proComFour.vue?vue&type=script&lang=js&"
export * from "./proComFour.vue?vue&type=script&lang=js&"
import style0 from "./proComFour.vue?vue&type=style&index=0&id=50f5cda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f5cda2",
  null
  
)

export default component.exports